import { useState } from 'react';
import './App.css';
import Docs from './components/Docs';
import Footer from './components/Footer';
import ConstructionLanding from './components/Home';

function App() {

  const [currentDoc, setCurrentDoc] = useState(null);

  return (
    <div className="App">
      <div className='header'>
        <img src={process.env.PUBLIC_URL+'/logo.png'} alt='logo'/>
        <h2>(713) 385 2814</h2>
      </div>
      <ConstructionLanding/>
      <Footer setDoc={setCurrentDoc}/>
      <Docs currentDoc={currentDoc} onClose={() => setCurrentDoc(null)}/>
    </div>
  );
}

export default App;
